const handleFormValue = (maxLengthAfterDot = 2) => (val) => {
  const separator = ['.', ','].find((separator) => val.includes(separator));

  if (!separator || val.indexOf(separator) === val.length - 1) return val;

  const [left, right] = val.split(separator);

  return ([
    left,
    right.length > maxLengthAfterDot ? right.slice(0, maxLengthAfterDot) : right
  ].join(separator));
};

module.exports = {
  handleFiatFieldResult: handleFormValue(2),
  handleCoinField: handleFormValue(8)
}
